unit View.Rt_Credito_Presumido.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UConstantes, UUtils, UPersonalizacao_Tabela.Interfaces,
  UPersonalizacao_Tabela, UWeb.Enum, UHelperServer, System.StrUtils;

type
  TFViewRt_Credito_PresumidoList = class(TForm)
    btNew: TButton;
    Rt_Credito_PresumidoDataset: TXDataWebDataSet;
    Rt_Credito_PresumidoDatasetid: TIntegerField;
    Rt_Credito_PresumidoDatasetccredpres: TIntegerField;
    Rt_Credito_PresumidoDatasetdescricao: TStringField;
    Rt_Credito_PresumidoDatasetapropria_via_nfe: TBooleanField;
    Rt_Credito_PresumidoDatasetapropria_via_evento: TBooleanField;
    Rt_Credito_PresumidoDatasetind_deduz_credpres: TBooleanField;
    Rt_Credito_PresumidoDatasetind_gcbs_credpres: TBooleanField;
    Rt_Credito_PresumidoDatasetind_gibs_credpres: TBooleanField;
    Rt_Credito_PresumidoDatasetexcluido: TBooleanField;
    Rt_Credito_PresumidoDatasetinclusao: TDateTimeField;
    Rt_Credito_PresumidoDatasetalteracao: TDateTimeField;
    Rt_Credito_PresumidoDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    tmrConsulta: TTimer;
    Rt_Credito_PresumidoDatasetindDecPag: TBooleanField;
    Rt_Credito_PresumidoDatasetindNFe: TBooleanField;
    Rt_Credito_PresumidoDatasetindNFCe: TBooleanField;
    Rt_Credito_PresumidoDatasetindNFSe: TBooleanField;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchChange(Sender: TObject);
    procedure edSearchKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure edSearchKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure tmrConsultaTimer(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure Rt_Credito_PresumidoDatasetdescricaoGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
    procedure WebDBTableControl1GetCellClass(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; var AClassName: string);
    procedure WebDBTableControl1GetCellData(Sender: TObject; ACol,
      ARow: Integer; AField: TField; var AValue: string);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
    FPersonalizacaoTabela: IPersonalizacao_Tabela;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewRt_Credito_PresumidoList: TFViewRt_Credito_PresumidoList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewRt_Credito_PresumidoList }

procedure TFViewRt_Credito_PresumidoList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewRt_Credito_PresumidoList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewRt_Credito_PresumidoList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewRt_Credito_PresumidoList, AElementID, Result, @AfterCreate);
end;

procedure TFViewRt_Credito_PresumidoList.edSearchChange(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewRt_Credito_PresumidoList.edSearchKeyDown(Sender: TObject;
  var Key: Word; Shift: TShiftState);
begin
  tmrConsulta.Enabled := False;

  if Key = 13 then
  begin
    FGridPlugin.SetFilterText(edSearch.Text, True);
  end;
end;

procedure TFViewRt_Credito_PresumidoList.edSearchKeyUp(Sender: TObject;
  var Key: Word; Shift: TShiftState);
begin
  tmrConsulta.Interval := FTimerConsulta;
  tmrConsulta.Enabled := True;
end;

procedure TFViewRt_Credito_PresumidoList.Rt_Credito_PresumidoDatasetdescricaoGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
begin
  Text := THelperServer.GetTextoMax100Caracteres(Sender.AsString);
end;

procedure TFViewRt_Credito_PresumidoList.tmrConsultaTimer(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);

  tmrConsulta.Enabled := False;
  tmrConsulta.Interval := FTimerConsulta;
end;

procedure TFViewRt_Credito_PresumidoList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewRt_Credito_PresumidoList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Ação' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      Rt_Credito_PresumidoDataset.Connection.Model.DefaultSchema.FindEntityType(Rt_Credito_PresumidoDataset.EntitySetName),
      Rt_Credito_PresumidoDataset.CurrentData
    );

    Button := TButton.Create(nil);
    Button.Caption := '<i class="fa fa-edit"></i>';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-link btn-primary btn-lg';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.setAttribute('data-test', 'btn_visualizar_credito_presumido');
  end;
end;

procedure TFViewRt_Credito_PresumidoList.WebDBTableControl1GetCellClass(
  Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string;
  var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['descricao']) of
      0: AClassName := 'text-left';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewRt_Credito_PresumidoList.WebDBTableControl1GetCellData(
  Sender: TObject; ACol, ARow: Integer; AField: TField; var AValue: string);
begin
  if ARow > 0 then
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['excluido', 'apropria_via_nfe', 'apropria_via_evento',
      'ind_deduz_credpres', 'ind_gcbs_credpres', 'ind_gibs_credpres', 'indDecPag', 'indNFe',
        'indNFCe', 'indNFSe']) of
      0, 1, 2, 3, 4, 5, 6, 7, 8, 9:
      begin
        if AValue = 'True' then
          AValue := '<i class="fas fa-check text-success"><i>'
        else if AValue = 'False' then
          AValue := '<i class="fas fa-times text-danger"><i>'
      end;
    end;
  end;
end;

procedure TFViewRt_Credito_PresumidoList.WebFormCreate(Sender: TObject);
begin
  FPersonalizacaoTabela := TPersonalizacao_Tabela.Create(Self.Name, WebDBTableControl1,
    cbPageSize);

  TUtils.SetValorDicionarioClasses('rt_credito_presumido', 'active');
  TUtils.SetValorDicionarioClasses('tributacoes_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_tributacoes', 'active');
  TUtils.SetValorDicionarioClasses('reforma_tributaria_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_reforma_tributaria', 'active');

  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(WebDBTableControl1, Rt_Credito_PresumidoDataset, lcPaginator,
    lbPaginationInfo);

  FGridPlugin.FDatasetPlugin.FOrderByPadrao := 'id desc';
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewRt_Credito_PresumidoList.WebFormShow(Sender: TObject);
begin
  if not TUtils.PossuiPermissao(Rt_Credito_PresumidoDataset.EntitySetName.ToLower, TTipoPermissao.INSERIR) then
    btNew.Enabled := False;
end;

procedure TFViewRt_Credito_PresumidoList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.rt_credito_presumido.list.pagination.info');
  btNew := TButton.Create('view.rt_credito_presumido.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.rt_credito_presumido.list.table');
  cbPageSize := TComboBox.Create('view.rt_credito_presumido.list.cbPageSize');
  edSearch := TEdit.Create('view.rt_credito_presumido.list.search');
  lcPaginator := TListControl.Create('view.rt_credito_presumido.list.pagination');
  Rt_Credito_PresumidoDataset := TXDataWebDataSet.Create(Self);
  Rt_Credito_PresumidoDatasetid := TIntegerField.Create(Self);
  Rt_Credito_PresumidoDatasetccredpres := TIntegerField.Create(Self);
  Rt_Credito_PresumidoDatasetdescricao := TStringField.Create(Self);
  Rt_Credito_PresumidoDatasetapropria_via_nfe := TBooleanField.Create(Self);
  Rt_Credito_PresumidoDatasetapropria_via_evento := TBooleanField.Create(Self);
  Rt_Credito_PresumidoDatasetind_deduz_credpres := TBooleanField.Create(Self);
  Rt_Credito_PresumidoDatasetind_gcbs_credpres := TBooleanField.Create(Self);
  Rt_Credito_PresumidoDatasetind_gibs_credpres := TBooleanField.Create(Self);
  Rt_Credito_PresumidoDatasetindDecPag := TBooleanField.Create(Self);
  Rt_Credito_PresumidoDatasetindNFe := TBooleanField.Create(Self);
  Rt_Credito_PresumidoDatasetindNFCe := TBooleanField.Create(Self);
  Rt_Credito_PresumidoDatasetindNFSe := TBooleanField.Create(Self);
  Rt_Credito_PresumidoDatasetexcluido := TBooleanField.Create(Self);
  Rt_Credito_PresumidoDatasetinclusao := TDateTimeField.Create(Self);
  Rt_Credito_PresumidoDatasetalteracao := TDateTimeField.Create(Self);
  Rt_Credito_PresumidoDatasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);
  tmrConsulta := TTimer.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  Rt_Credito_PresumidoDataset.BeforeLoadDFMValues;
  Rt_Credito_PresumidoDatasetid.BeforeLoadDFMValues;
  Rt_Credito_PresumidoDatasetccredpres.BeforeLoadDFMValues;
  Rt_Credito_PresumidoDatasetdescricao.BeforeLoadDFMValues;
  Rt_Credito_PresumidoDatasetapropria_via_nfe.BeforeLoadDFMValues;
  Rt_Credito_PresumidoDatasetapropria_via_evento.BeforeLoadDFMValues;
  Rt_Credito_PresumidoDatasetind_deduz_credpres.BeforeLoadDFMValues;
  Rt_Credito_PresumidoDatasetind_gcbs_credpres.BeforeLoadDFMValues;
  Rt_Credito_PresumidoDatasetind_gibs_credpres.BeforeLoadDFMValues;
  Rt_Credito_PresumidoDatasetindDecPag.BeforeLoadDFMValues;
  Rt_Credito_PresumidoDatasetindNFe.BeforeLoadDFMValues;
  Rt_Credito_PresumidoDatasetindNFCe.BeforeLoadDFMValues;
  Rt_Credito_PresumidoDatasetindNFSe.BeforeLoadDFMValues;
  Rt_Credito_PresumidoDatasetexcluido.BeforeLoadDFMValues;
  Rt_Credito_PresumidoDatasetinclusao.BeforeLoadDFMValues;
  Rt_Credito_PresumidoDatasetalteracao.BeforeLoadDFMValues;
  Rt_Credito_PresumidoDatasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  tmrConsulta.BeforeLoadDFMValues;
  try
    Name := 'FViewRt_Credito_PresumidoList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellData', 'WebDBTableControl1GetCellData');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellClass', 'WebDBTableControl1GetCellClass');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'A'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'C'#243'd.';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'ccredpres';
      Title := 'ccredpres';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'descricao';
      Title := 'Descri'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'apropria_via_nfe';
      Title := 'apropria_via_nfe';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'apropria_via_evento';
      Title := 'apropria_via_evento';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'ind_deduz_credpres';
      Title := 'ind_deduz_credpres';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'ind_gcbs_credpres';
      Title := 'ind_gcbs_credpres';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'ind_gibs_credpres';
      Title := 'ind_gibs_credpres';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'indDecPag';
      Title := 'indDecPag';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'indNFCe';
      Title := 'indNFCe';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'indNFe';
      Title := 'indNFe';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'indNFSe';
      Title := 'indNFSe';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'Exclu'#237'do?';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'Inclus'#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'Altera'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'Exclus'#227'o';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnKeyDown', 'edSearchKeyDown');
    SetEvent(edSearch, Self, 'OnKeyUp', 'edSearchKeyUp');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    Rt_Credito_PresumidoDataset.SetParentComponent(Self);
    Rt_Credito_PresumidoDataset.Name := 'Rt_Credito_PresumidoDataset';
    Rt_Credito_PresumidoDataset.EntitySetName := 'Rt_Credito_Presumido';
    Rt_Credito_PresumidoDataset.Connection := DMConnection.ApiConnection;
    Rt_Credito_PresumidoDataset.Left := 72;
    Rt_Credito_PresumidoDataset.Top := 144;
    Rt_Credito_PresumidoDatasetid.SetParentComponent(Rt_Credito_PresumidoDataset);
    Rt_Credito_PresumidoDatasetid.Name := 'Rt_Credito_PresumidoDatasetid';
    Rt_Credito_PresumidoDatasetid.FieldName := 'id';
    Rt_Credito_PresumidoDatasetid.Required := True;
    Rt_Credito_PresumidoDatasetccredpres.SetParentComponent(Rt_Credito_PresumidoDataset);
    Rt_Credito_PresumidoDatasetccredpres.Name := 'Rt_Credito_PresumidoDatasetccredpres';
    Rt_Credito_PresumidoDatasetccredpres.FieldName := 'ccredpres';
    Rt_Credito_PresumidoDatasetccredpres.Required := True;
    Rt_Credito_PresumidoDatasetdescricao.SetParentComponent(Rt_Credito_PresumidoDataset);
    Rt_Credito_PresumidoDatasetdescricao.Name := 'Rt_Credito_PresumidoDatasetdescricao';
    Rt_Credito_PresumidoDatasetdescricao.FieldName := 'descricao';
    Rt_Credito_PresumidoDatasetdescricao.Required := True;
    SetEvent(Rt_Credito_PresumidoDatasetdescricao, Self, 'OnGetText', 'Rt_Credito_PresumidoDatasetdescricaoGetText');
    Rt_Credito_PresumidoDatasetdescricao.Size := 255;
    Rt_Credito_PresumidoDatasetapropria_via_nfe.SetParentComponent(Rt_Credito_PresumidoDataset);
    Rt_Credito_PresumidoDatasetapropria_via_nfe.Name := 'Rt_Credito_PresumidoDatasetapropria_via_nfe';
    Rt_Credito_PresumidoDatasetapropria_via_nfe.FieldName := 'apropria_via_nfe';
    Rt_Credito_PresumidoDatasetapropria_via_evento.SetParentComponent(Rt_Credito_PresumidoDataset);
    Rt_Credito_PresumidoDatasetapropria_via_evento.Name := 'Rt_Credito_PresumidoDatasetapropria_via_evento';
    Rt_Credito_PresumidoDatasetapropria_via_evento.FieldName := 'apropria_via_evento';
    Rt_Credito_PresumidoDatasetind_deduz_credpres.SetParentComponent(Rt_Credito_PresumidoDataset);
    Rt_Credito_PresumidoDatasetind_deduz_credpres.Name := 'Rt_Credito_PresumidoDatasetind_deduz_credpres';
    Rt_Credito_PresumidoDatasetind_deduz_credpres.FieldName := 'ind_deduz_credpres';
    Rt_Credito_PresumidoDatasetind_gcbs_credpres.SetParentComponent(Rt_Credito_PresumidoDataset);
    Rt_Credito_PresumidoDatasetind_gcbs_credpres.Name := 'Rt_Credito_PresumidoDatasetind_gcbs_credpres';
    Rt_Credito_PresumidoDatasetind_gcbs_credpres.FieldName := 'ind_gcbs_credpres';
    Rt_Credito_PresumidoDatasetind_gibs_credpres.SetParentComponent(Rt_Credito_PresumidoDataset);
    Rt_Credito_PresumidoDatasetind_gibs_credpres.Name := 'Rt_Credito_PresumidoDatasetind_gibs_credpres';
    Rt_Credito_PresumidoDatasetind_gibs_credpres.FieldName := 'ind_gibs_credpres';
    Rt_Credito_PresumidoDatasetindDecPag.SetParentComponent(Rt_Credito_PresumidoDataset);
    Rt_Credito_PresumidoDatasetindDecPag.Name := 'Rt_Credito_PresumidoDatasetindDecPag';
    Rt_Credito_PresumidoDatasetindDecPag.FieldName := 'indDecPag';
    Rt_Credito_PresumidoDatasetindNFe.SetParentComponent(Rt_Credito_PresumidoDataset);
    Rt_Credito_PresumidoDatasetindNFe.Name := 'Rt_Credito_PresumidoDatasetindNFe';
    Rt_Credito_PresumidoDatasetindNFe.FieldName := 'indNFe';
    Rt_Credito_PresumidoDatasetindNFCe.SetParentComponent(Rt_Credito_PresumidoDataset);
    Rt_Credito_PresumidoDatasetindNFCe.Name := 'Rt_Credito_PresumidoDatasetindNFCe';
    Rt_Credito_PresumidoDatasetindNFCe.FieldName := 'indNFCe';
    Rt_Credito_PresumidoDatasetindNFSe.SetParentComponent(Rt_Credito_PresumidoDataset);
    Rt_Credito_PresumidoDatasetindNFSe.Name := 'Rt_Credito_PresumidoDatasetindNFSe';
    Rt_Credito_PresumidoDatasetindNFSe.FieldName := 'indNFSe';
    Rt_Credito_PresumidoDatasetexcluido.SetParentComponent(Rt_Credito_PresumidoDataset);
    Rt_Credito_PresumidoDatasetexcluido.Name := 'Rt_Credito_PresumidoDatasetexcluido';
    Rt_Credito_PresumidoDatasetexcluido.FieldName := 'excluido';
    Rt_Credito_PresumidoDatasetinclusao.SetParentComponent(Rt_Credito_PresumidoDataset);
    Rt_Credito_PresumidoDatasetinclusao.Name := 'Rt_Credito_PresumidoDatasetinclusao';
    Rt_Credito_PresumidoDatasetinclusao.FieldName := 'inclusao';
    Rt_Credito_PresumidoDatasetinclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    Rt_Credito_PresumidoDatasetalteracao.SetParentComponent(Rt_Credito_PresumidoDataset);
    Rt_Credito_PresumidoDatasetalteracao.Name := 'Rt_Credito_PresumidoDatasetalteracao';
    Rt_Credito_PresumidoDatasetalteracao.FieldName := 'alteracao';
    Rt_Credito_PresumidoDatasetalteracao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    Rt_Credito_PresumidoDatasetexclusao.SetParentComponent(Rt_Credito_PresumidoDataset);
    Rt_Credito_PresumidoDatasetexclusao.Name := 'Rt_Credito_PresumidoDatasetexclusao';
    Rt_Credito_PresumidoDatasetexclusao.FieldName := 'exclusao';
    Rt_Credito_PresumidoDatasetexclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := Rt_Credito_PresumidoDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
    tmrConsulta.SetParentComponent(Self);
    tmrConsulta.Name := 'tmrConsulta';
    tmrConsulta.Enabled := False;
    SetEvent(tmrConsulta, Self, 'OnTimer', 'tmrConsultaTimer');
    tmrConsulta.Left := 296;
    tmrConsulta.Top := 200;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    Rt_Credito_PresumidoDataset.AfterLoadDFMValues;
    Rt_Credito_PresumidoDatasetid.AfterLoadDFMValues;
    Rt_Credito_PresumidoDatasetccredpres.AfterLoadDFMValues;
    Rt_Credito_PresumidoDatasetdescricao.AfterLoadDFMValues;
    Rt_Credito_PresumidoDatasetapropria_via_nfe.AfterLoadDFMValues;
    Rt_Credito_PresumidoDatasetapropria_via_evento.AfterLoadDFMValues;
    Rt_Credito_PresumidoDatasetind_deduz_credpres.AfterLoadDFMValues;
    Rt_Credito_PresumidoDatasetind_gcbs_credpres.AfterLoadDFMValues;
    Rt_Credito_PresumidoDatasetind_gibs_credpres.AfterLoadDFMValues;
    Rt_Credito_PresumidoDatasetindDecPag.AfterLoadDFMValues;
    Rt_Credito_PresumidoDatasetindNFe.AfterLoadDFMValues;
    Rt_Credito_PresumidoDatasetindNFCe.AfterLoadDFMValues;
    Rt_Credito_PresumidoDatasetindNFSe.AfterLoadDFMValues;
    Rt_Credito_PresumidoDatasetexcluido.AfterLoadDFMValues;
    Rt_Credito_PresumidoDatasetinclusao.AfterLoadDFMValues;
    Rt_Credito_PresumidoDatasetalteracao.AfterLoadDFMValues;
    Rt_Credito_PresumidoDatasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
    tmrConsulta.AfterLoadDFMValues;
  end;
end;

end.
